export default __webpack_public_path__ + "static/media/Education.e71f47d2.png";